import { render } from "./sitebar.vue?vue&type=template&id=c4953fa8&scoped=true"
import script from "./sitebar.vue?vue&type=script&lang=js"
export * from "./sitebar.vue?vue&type=script&lang=js"

import "./sitebar.vue?vue&type=style&index=0&id=c4953fa8&scoped=true&lang=scss"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4953fa8"]])

export default __exports__